module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-staying-on-track.3543df5f.png";